module.exports = __webpack_public_path__ + "static/blackjack-60b69482e703f4f9084b4a0f92978e9e.png";